// extracted by mini-css-extract-plugin
module.exports = {"rating":"Pj-z","numberOfStars":"Qj-z","count":"Rj-z"};